import { render, staticRenderFns } from "./PerguntaEdit.vue?vue&type=template&id=53bfa5d0&scoped=true&"
import script from "./PerguntaEdit.vue?vue&type=script&lang=js&"
export * from "./PerguntaEdit.vue?vue&type=script&lang=js&"
import style0 from "./PerguntaEdit.vue?vue&type=style&index=0&id=53bfa5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfa5d0",
  null
  
)

export default component.exports